import { z } from 'zod';

export const LocaleNameSchema = z.enum(['zh-CN', 'en-GB', 'cy-GB']);
export type LocaleName = z.infer<typeof LocaleNameSchema>;

export const SettingLocaleNameSchema = z.enum([
  'zh-CN',
  'en-GB',
  'cy-GB',
  'auto',
]);
export type SettingLocaleName = z.infer<typeof SettingLocaleNameSchema>;

export const SettingSchema = z.object({
  localeName: SettingLocaleNameSchema,
  themeName: z.enum(['dark', 'light', 'auto']),
});

export type Setting = z.infer<typeof SettingSchema>;
